export const SETTINGS_GROUP_FIELD_NAME = '_group'

export const VALUE_RICHTEXT_TYPE = 'richtext'
